import * as React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { HouseSunset } from '../HouseIcons';
import { DarkLawn } from '../Lawn';
import styles from './styles';

export interface Props {
  classes: any;
  topper: boolean;
}

export const AppCta = (props: Props) => (
  <div className={`row center-xs bottom-xs ${props.classes.getStarted}`}>
    {props.topper && <div className={props.classes.getStartedTopper} />}
    <div className={`row col-xs-12 center-xs ${props.classes.inner}`}>
      <div className="col-xs-12">
        <h2 className={props.classes.getStartedHeader}>Get Started</h2>
        <p className={props.classes.subHeader}>
          Download the Torii app to make an offer or get started online{' '}
          <br className="no-mobile" />
          Currently available in Massachusetts
        </p>
      </div>

      <div
        className={`row col-xs-12 center-xs between-xs ${props.classes.appButtonsContainer}`}
        style={{ maxWidth: 390 }}
      >
        <a
          className={props.classes.iosButton}
          data-alt="iOS link"
          href="https://itunes.apple.com/us/app/torii-real-estate/id1362196303?ls=1&mt=8"
          rel="noopener noreferrer"
          target="_blank"
        >
          Torii for iOS
        </a>
        <a
          className={props.classes.androidButton}
          data-alt="Android link"
          href="https://play.google.com/store/apps/details?id=com.toriiapp.android"
          rel="noopener noreferrer"
          target="_blank"
        >
          Torii for Android
        </a>
      </div>
    </div>

    <div className={props.classes.lawnContainer}>
      <div className={props.classes.lawnInner}>
        <DarkLawn />
      </div>
    </div>
    <div className={props.classes.houseIconContainer}>
      <div className={props.classes.houseIcon}>
        <HouseSunset />
      </div>
    </div>
  </div>
);

const mapStateToProps = (state: any) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(withStyles(styles)(AppCta));
